(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('oranevia-payment-label')) {
    customElements.define('oranevia-payment-label', class extends HTMLElement {
      connectedCallback() {
        const translate = () => {
          const link = this.querySelector('#more-payment-options-link');
          const label = this.dataset.label;
          if (link && label && link.textContent !== label) link.textContent = label;
        };
        this.observer = new MutationObserver(translate);
        this.observer.observe(this, { childList: true, subtree: true, characterData: true });
        translate();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
